export const Pin = ({ size = "16" }: { size?: string }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.9259 12.0301L1.04057 15.9014L0.0979004 14.9587L3.98323 11.0861L4.9259 12.0301ZM9.1259 13.8734C9.73672 13.26 10.1773 12.4982 10.4043 11.6629C10.6313 10.8276 10.6369 9.94754 10.4206 9.10939L10.2126 8.25873L12.6259 5.83206L13.0059 6.21273C13.2865 6.50283 13.6602 6.68492 14.0616 6.72709C14.463 6.76927 14.8665 6.66884 15.2012 6.44339C15.3987 6.3029 15.5631 6.12103 15.6831 5.91048C15.803 5.69992 15.8756 5.46574 15.8958 5.22425C15.916 4.98276 15.8833 4.73978 15.7999 4.51223C15.7166 4.28469 15.5846 4.07805 15.4132 3.90673L12.1319 0.622061C11.8511 0.332312 11.4774 0.150464 11.0761 0.1083C10.6748 0.0661364 10.2715 0.166339 9.93657 0.391395C9.73897 0.531835 9.57438 0.713691 9.45429 0.924279C9.3342 1.13487 9.2615 1.36912 9.24125 1.6107C9.221 1.85227 9.2537 2.09536 9.33706 2.323C9.42042 2.55064 9.55243 2.75735 9.7239 2.92873L10.1552 3.35939L7.74123 5.78606L6.8959 5.57873C6.05703 5.36136 5.17598 5.36638 4.33964 5.59329C3.5033 5.8202 2.74054 6.26118 2.12657 6.87273L1.89123 7.10873L8.89123 14.1087L9.1259 13.8734Z"
      fill="currentColor"
    />
  </svg>
);
